export default "__VITE_ASSET__D62kWyr9__"